import { render, staticRenderFns } from "./Wordmark.vue?vue&type=template&id=063d2e12&scoped=true"
import script from "./Wordmark.vue?vue&type=script&lang=js"
export * from "./Wordmark.vue?vue&type=script&lang=js"
import style0 from "./Wordmark.vue?vue&type=style&index=0&id=063d2e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d2e12",
  null
  
)

export default component.exports